import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { AccordionItem } from '@e3dc-react/shell/Elements/Accordion'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { DynamicTariffSettingsFormProvider } from './form'
import ActiveContractCard from 'src/Libs/dynamic-power-prices/components/power-price-settings/ActiveContractCard'
import ExtensionsImage from 'src/Libs/dynamic-power-prices/components/power-price-settings/form-content/ExtensionsImage'
import { Paper, Stack } from '@mui/material'
import { J2Validate } from '@e3dc-react/icons'
import useInstallationExtensionData from 'src/Libs/installation-extensions/hooks/extensions/use-installation-extension-data'
import { DynamicPricesSettings } from 'src/Libs/dynamic-power-prices/types'

const useStyles = makeStyles()(theme => ({
  contentAccordion: {
    padding: theme.spacing(0),
  },
  headerContent: {
    [theme.breakpoints.down('md')]: {
      paddingLeft: theme.spacing(4),
    },
  },
  connectedStatus: {
    border: `1px solid ${theme.palette.grey.grey06}`,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(2),
    gap: theme.spacing(1),
  },
  extensionConnected: {
    margin: theme.spacing(2, 4, 2),
  },
}))

interface Props {
  installationId?: string
  hasWritingRights?: boolean
  dynamicPricesSettings: DynamicPricesSettings | null
  handleDynamicPricesSettingsUpdate: (newValues: DynamicPricesSettings) => Promise<void>
  expanded?: boolean
}

/**
 * Dynamic Tariff Settings component
 */
const DynamicTariffSettings: React.FC<Props> = ({
  installationId,
  hasWritingRights = true,
  dynamicPricesSettings,
  expanded,
  handleDynamicPricesSettingsUpdate,
}) => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()
  const { installationExtensionsState, isActiveExtensionAvailable } = useInstallationExtensionData(installationId)

  return (
    <AccordionItem
      title={t('dynamic-tariff-settings.title')}
      contentClassName={classes.contentAccordion}
      headerContentClassName={classes.headerContent}
      expanded={expanded}
    >
      {isActiveExtensionAvailable && (
        <Stack className={classes.extensionConnected}>
          <ActiveContractCard
            image={<ExtensionsImage installationExtensionsState={installationExtensionsState} />}
            suffix={
              <Paper className={classes.connectedStatus} elevation={0}>
                {t('installation-extensions.ostrom.connected')}
                <J2Validate color="primary" />
              </Paper>
            }
          />
        </Stack>
      )}
      {!isActiveExtensionAvailable && (
        <DynamicTariffSettingsFormProvider
          hasWritingRights={hasWritingRights}
          dynamicPricesSettings={dynamicPricesSettings}
          handleDynamicPricesSettingsUpdate={handleDynamicPricesSettingsUpdate}
        />
      )}
    </AccordionItem>
  )
}

export default DynamicTariffSettings
